export const baseImageUrl = process.env.REACT_APP_URL;

